export default __webpack_public_path__ + "static/media/info-warning.183c99d7.svg";